import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext, getIn } from 'formik';
import { lookupsJson } from '@ourbranch/lookups';

import Field from 'core/components/form/form.v2';
import { SubRiskCollapsibleSection } from 'common/components/farm/locations/risks/sub-risks/sub-risk-collapsible-section';
import { AppliedTag } from 'common/components/farm/applied-tag';
import useStyles from '../liability-coverages-styles';

const careProvidedToOthersOptions = lookupsJson.farm.careProvidedToOthersOptions;

const FIELD_NAME = 'farmLiabilityCoverage.careProvidedToOthers';
const DESCRIPTION_FIELD_NAME = 'farmLiabilityCoverage.careProvidedToOthersDescription';

const CareProvidedToOthers = ({ disabled = false, onChangeActive }) => {
  const classes = useStyles();
  const { values } = useFormikContext();

  const currentValue = getIn(values, FIELD_NAME) || 0;

  return (
    <div className={classes.sectionContainer} id="farmLiabilityCoverage.careProvidedToOthers">
      <SubRiskCollapsibleSection
        type="secondary"
        content={<div className={classes.headerText}>Care provided to others</div>}
        contentRight={currentValue > 0 ? <AppliedTag /> : null}
        initialOpen={currentValue > 0}
      >
        <Field
          xs={12}
          type="select"
          id={FIELD_NAME}
          name={FIELD_NAME}
          mode="dark"
          label="Number of people"
          options={careProvidedToOthersOptions}
          disabled={disabled}
          onChange={onChangeActive}
        />
        {currentValue > 0 && (
          <Field
            xs={12}
            type="textarea"
            id={DESCRIPTION_FIELD_NAME}
            name={DESCRIPTION_FIELD_NAME}
            mode="dark"
            label="Description (required)"
            disabled={disabled}
          />
        )}
      </SubRiskCollapsibleSection>
    </div>
  );
};

CareProvidedToOthers.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onChangeActive: PropTypes.func.isRequired
};

export default CareProvidedToOthers;
